<template>
  <a :href="`/blogs/${article.handle}`" class="gs">
    <ImageField
      class="gs__image"
      :obj="{ url: article.image, alt: article.title, width: 256, height: 194 }"
      width-param="width"
      sizes="500px"
    />
    <div class="gs__info">
      <div class="gs__tag-time">
        <span v-if="tag" class="gs__tag" :aria-label="`Tag: ${tag}`">{{ tag }}</span>
        <span v-if="tag && timeToRead" class="gs__seperator" aria-hidden="true"></span>
        <span v-if="timeToRead" class="gs__time" :aria-label="`Estimated reading time: ${timeToRead} minutes`">{{ timeToRead }} min Read</span>
      </div>
      <h2 class="gs__title">{{ article.title }}</h2>
    </div>
  </a>
</template>

<script setup>
  import { computed, toRefs } from 'vue';
  import ImageField from '../../global/image.vue';

  const props = defineProps({
    article: {
      type: Object,
      required: true,
    },
  });

  const { article } = toRefs(props);

  const tag = computed(() => {
    const catTag = article.value.tags.filter((tag) => tag.includes('category:'));
    if (catTag.length) {
      return catTag[0].split(':')[1];
    }
  });

  const timeToRead = computed(() => {
    const timeTag = article.value.tags.filter((tag) => tag.includes('time:'));
    if (timeTag.length) {
      return timeTag[0].split(':')[1];
    }
  });
</script>
